import { render, staticRenderFns } from "./CompanyInput.vue?vue&type=template&id=cbb81422&"
import script from "./CompanyInput.vue?vue&type=script&lang=ts&"
export * from "./CompanyInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports